import React from "react";
import { FaPhone, FaWhatsapp, FaHandPointUp } from "react-icons/fa";
import "./TaxiForSalePriceandPhone.css";

const TaxiForSalePriceandPhone = ({ price, phoneNumber, whatsappLink, taxiId }) => {
  const cleanedPhoneNumber = phoneNumber ? phoneNumber.replace(/\D/g, '') : '';

  return (
    <div className="taxi-price-phone">
      <div className="buttons-container">
        {cleanedPhoneNumber && (
          <button
            className="call-button"
            onClick={() => {
              if (window.gtag) {
                window.gtag('event', 'click_calltaxiforsale', {
                  event_category: 'engagement',
                  event_label: `מונית ${taxiId} - ${cleanedPhoneNumber}`,
                  value: 1,
                });
              }

              window.location.href = `tel:${cleanedPhoneNumber}`;
            }}
          >
            <FaPhone className="iconwhatsappandphone" />
          </button>
        )}

        {whatsappLink && (
          <div className="whatsapp-container">
            <button
              className="whatsapp-button"
              onClick={() => {
                if (window.gtag) {
                  window.gtag('event', 'click_whatsapptaxiforsale', {
                    event_category: 'engagement',
                    event_label: `מונית ${taxiId} - ${cleanedPhoneNumber}`,
                    value: 1,
                  });
                }

                window.open(whatsappLink, "_blank");
              }}
            >
              <FaWhatsapp className="iconwhatsappandphone" />
            </button>
            <FaHandPointUp className="arrow-icon" />
          </div>
        )}
      </div>

      <h3>חדש! שלח הודעת וואטספ לבעל המונית</h3>
      <div className="spacertaxiforsalepricesectiono">
        <hr className="price-divider" />
      </div>

      <div className="taxiforsaleprice">
        {Number(price) <= 4 ? (
          <div className="no-price-message">המפרסם פירסם ללא מחיר</div>
        ) : (
          <>
            <h2 className="taxi-price">{price} ₪</h2>
            <h4 className="fixpricetaxiforsale">המחיר לא כולל מע"מ</h4>
          </>
        )}
      </div>
    </div>
  );
};

export default TaxiForSalePriceandPhone;
